import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import SimpleSteps from "@/components/navigation/Steps";
import GeneralDescription from "./general_description";
import LocationProperty from "./location";
import Amenities from "./amenities";
import UploadMedia from "./upload_media";
import { useMyPropertiesCount } from "@/_actions/propertiesActions";

export default function Create() {
  const [propertyId, setPropertyId] = useState(null);
  const [step, setStep] = useState(1);
  const navigate = useNavigate();

  const { data: allPropertiesCount, isLoading } = useMyPropertiesCount();
  const canCreate = Boolean(allPropertiesCount?.can_publish);

  function setStatus(index, currentIndex) {
    if (index <= currentIndex) return "current";
    return "upcoming";
  }

  const propertyCreationSteps = useMemo(() => {
    return [
      {
        name: "Información General",
        description: "Inmobiliaria o agente independiente",
        href: "#",
        status: setStatus(1, step),
      },
      {
        name: "Amenidades",
        description: "Selecciona las amenidades de la propiedad",
        href: "#",
        status: setStatus(2, step),
      },
      {
        name: "Ubicación",
        description: "Define para preparar tu plan",
        href: "#",
        status: setStatus(3, step),
      },
      {
        name: "Fotografías",
        description: "Contrata tu plan y accede a PRO",
        href: "#",
        status: setStatus(4, step),
      },
    ];
  }, [step]);

  useEffect(() => {
    if (!isLoading && allPropertiesCount && !canCreate) {
      navigate("/subscription", { replace: true });
    }
  }, [isLoading, allPropertiesCount, canCreate, navigate]);

  useEffect(() => {
    if (
      propertyId !== null &&
      propertyId !== undefined &&
      propertyId !== "null"
    ) {
      localStorage.setItem("localId", propertyId);
    }
  }, [propertyId]);

  if (isLoading || !allPropertiesCount) return null;
  if (!canCreate) return null;

  const gotoAmenitiesStep = (response) => {
    setPropertyId(response?.data?.id || localStorage.getItem("localId"));
    setStep(2);
  };

  const gotoLocationStep = (response) => {
    setPropertyId(response?.data?.id || localStorage.getItem("localId"));
    setStep(3);
  };

  const gotoMediaStep = () => {
    setPropertyId(localStorage.getItem("localId"));
    try {
      setStep(4);
    } catch (err) {
      $log.error(err);
    }
  };

  const finish = () => {
    navigate("/properties");
  };

  const goBack = () => {
    setStep((prev) => prev - 1);
  };

  return (
    <div className="m-5 rounded bg-white p-5">
      <SimpleSteps steps={propertyCreationSteps} />

      {(step === 1 || step === "1") && (
        <GeneralDescription
          callBack={gotoAmenitiesStep}
          propertyId={propertyId}
          action="create"
        />
      )}

      {(step === 2 || step === "2") && (
        <Amenities
          callBack={gotoLocationStep}
          propertyId={propertyId}
          goBack={goBack}
          action="create"
        />
      )}

      {(step === 3 || step === "3") && (
        <LocationProperty
          callBack={gotoMediaStep}
          propertyId={propertyId}
          goBack={goBack}
          action="create"
        />
      )}

      {(step === 4 || step === "4") && (
        <UploadMedia
          callBack={finish}
          propertyId={propertyId}
          goBack={goBack}
          action="create"
        />
      )}
    </div>
  );
}
